import { isPublicUrlAccess } from '@lib/public-url-access';
import { defaultHeaders } from '@lib/server-http';
import { MARKERS } from '@lib/performance-logging';
import { getApiUrl } from '@lib/environments.const';

const API_URL: string = getApiUrl();

if (!isPublicUrlAccess()) {
  const settings = {
    method: 'GET',
    url: `${API_URL}/api/w2/sessions/validate`,
    headers: defaultHeaders,
  };

  if (window.location.href.includes('apply-cards')) {
    settings.url = `${settings.url}?cards_user=true`;
  }

  window['validationData'] = null;
  window['validationError'] = null;
  window.performance.mark(MARKERS.VALIDATE_CALL_START);
  fetch(settings.url, {
    method: 'GET',
    headers: settings.headers || {}, // Add headers if provided
  })
  .then(response => {
    window.performance.mark(MARKERS.VALIDATE_CALL_END);

    if (!response.ok) {
      return response.json().then(data => {
        throw data;
      });
    }
    return response.json();
  })
  .then(data => {
    window['validationData'] = data;
  })
  .catch(error => {
    window['validationError'] = error;
  })
  .finally(() => window.dispatchEvent(new Event('validation-done')));
}